import { useMemo } from 'react';
// @ts-expect-error untyped import
import FilterOperatorDisplay from 'customer-data-filters/components/operator/FilterOperatorDisplay';
import { getEventDateFilterProperty } from './event-date-filter-property';
// @ts-expect-error untyped import
import { getEventDateTableLabel } from '../../event-date-interval-utils';
import { toDSFilterOperator, getLabelString, buildSpecialOptionsByReferenceType, toDSFieldRecord
// @ts-expect-error untyped import
} from '../../xo-filter-utils';
import { getIsUngated, useFilterRelevantUserInfo } from '../../../../../shared/lib/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getMappedProps = (filter, property, userGates) => {
  const {
    filter: propertyFilter
  } = filter;
  const operator = toDSFilterOperator(propertyFilter, property, undefined, userGates);
  const field = toDSFieldRecord(property);
  return {
    currencyCode: 'USD',
    isReadOnly: true,
    isXoEnabled: true,
    operator,
    getSpecialOptionsForReferenceType: buildSpecialOptionsByReferenceType(undefined, undefined),
    getLabelString: () => getLabelString(field),
    getReferencedObjectType: () => undefined,
    getFamilyValueResolver: () => null
  };
};
const AllEventsFilterLabel = ({
  filter
}) => {
  const tableLabel = getEventDateTableLabel();
  const property = getEventDateFilterProperty();
  const {
    userGates
  } = useFilterRelevantUserInfo();
  const filterOperatorDisplayProps = useMemo(() => getMappedProps(filter, property, userGates), [filter, property, userGates]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("span", {
      style: {
        display: 'block',
        fontWeight: 600,
        marginBottom: -4
      },
      children: tableLabel
    }), /*#__PURE__*/_jsx("span", {
      children: filterOperatorDisplayProps.operator ? /*#__PURE__*/_jsx(FilterOperatorDisplay, Object.assign({}, filterOperatorDisplayProps, {
        getIsUngated: gate => getIsUngated(gate, userGates)
      })) : /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx("strong", {
          children: filterOperatorDisplayProps.getLabelString()
        })
      })
    })]
  });
};
export default AllEventsFilterLabel;